import { debounce } from '@js/util/helpers'
import swiperHandleKeyboardFocus from '@js/util/swiper-handle-keyboard-focus'
import Swiper from 'swiper'

let tabs = document.querySelectorAll('.wpce-tabs')
for (let tab of tabs) {
  let swiper_id = tab.dataset.swiperId
  let nav = tab.querySelector('.tabs-nav')
  let navItems = nav.querySelectorAll('.tabs-nav-list-item')
  let activeClass = 'active'
  let list = nav.querySelector('.tabs-nav-list')

  let swiper = new Swiper(`#${swiper_id}`, {
    autoHeight: true,
    threshold: 30,
    /*
     * Disable allowTouchMove & simulateTouch to make sure no drag event is triggered
     * when interacting with the content inside a tab (e.g. on a form field)
     */
    allowTouchMove: false,
    simulateTouch: false,
  })

  swiperHandleKeyboardFocus(swiper)

  let handleNav = () => {
    for (let item of navItems) {
      item.classList.remove(activeClass)
    }
    let activeItem = navItems[swiper.activeIndex]
    activeItem.classList.add(activeClass)

    let minScroll = 0
    let maxScroll = nav.scrollWidth - nav.clientWidth
    let computedScroll =
      activeItem.offsetLeft -
      parseFloat(getComputedStyle(activeItem).marginLeft) -
      (0.5 * list.offsetWidth - 0.5 * activeItem.offsetWidth)
    let effectiveScroll = Math.max(Math.min(computedScroll, maxScroll), minScroll)

    tab.classList.toggle('scrollable', maxScroll > 0)
    tab.classList.toggle('left-aligned', effectiveScroll === 0)
    tab.classList.toggle('right-aligned', effectiveScroll === maxScroll)

    const scrollBefore = nav.scrollLeft
    nav.scrollTo({
      left: effectiveScroll,
      behavior: 'smooth',
    })

    // behavior: smooth does not work in Safari
    // so we need to check if the scroll position has changed and scroll again
    setTimeout(() => {
      if (nav.scrollLeft !== scrollBefore) return

      nav.scrollTo(effectiveScroll, 0)
    }, 20)
  }

  swiper.on('slideChange', () => {
    const offset = tab.closest('.tabs-section').getBoundingClientRect().top + window.scrollY - 20

    if (window.scrollY > offset) {
      window.scrollTo({
        top: offset,
        behavior: 'smooth',
      })
    }

    handleNav()

    let activatedNavItem = nav.querySelector(`[data-index='${swiper.activeIndex}']`)
    if (activatedNavItem.getAttribute('data-ref')) {
      window.history.pushState(null, null, '#' + activatedNavItem.getAttribute('data-ref'))
    }

    for (let navItem of navItems) {
      let isCurrent = activatedNavItem === navItem
      navItem.tabIndex = isCurrent ? 0 : -1
      navItem.setAttribute('aria-selected', isCurrent ? 'true' : 'false')
    }
  })

  tab.addEventListener(
    'accordion:toggled',
    debounce(() => {
      swiper.updateAutoHeight(300)
    }, 100),
  )

  navItems.forEach((item, index) => {
    item.addEventListener('click', () => {
      swiper.slideTo(item.getAttribute('data-index'), 500)
    })

    item.addEventListener('keydown', event => {
      let goPrevious = event.key === 'ArrowUp' || event.key === 'ArrowLeft'
      let goNext = event.key === 'ArrowDown' || event.key === 'ArrowRight'

      let newIndex
      if (goPrevious) {
        newIndex = (index - 1 + navItems.length) % navItems.length
      }

      if (goNext) {
        newIndex = (index + 1) % navItems.length
      }

      if (goPrevious || goNext) {
        event.preventDefault()

        swiper.slideTo(Number(navItems[newIndex].dataset.index), 500)

        // Need timeout to only focus when new button is visible
        setTimeout(() => {
          navItems[newIndex].focus()
        }, 0)
      }
    })
  })

  let selectedTab = window.location.hash
  selectedTab = selectedTab.toLowerCase()
  selectedTab = selectedTab.slice(1)
  if (selectedTab) {
    let navElement = nav.querySelector(`[data-ref='${selectedTab}']`)
    if (navElement) {
      let tabIndex = navElement.dataset.index
      swiper.slideTo(tabIndex, 0, false)
    }
  }

  handleNav()
  window.addEventListener('resizeEnd', handleNav)
}
